import { apiGet, apiPatch } from './client';
import type { AgendaChecklistItem, AgendaMarkRequest } from '../types/AgendaChecklist';

// Daily agenda checklist for the CURRENT tenant + today (tenant-context).
export function getAgendaToday(opts?: { tenantId?: number }): Promise<AgendaChecklistItem[]> {
  return apiGet<AgendaChecklistItem[]>('/api/agenda/today', opts);
}

// Mark/unmark one action. Resolves on success (204); rejects with the server
// message (e.g. "comment_required") on 400.
export function markAgendaItem(req: AgendaMarkRequest): Promise<void> {
  return apiPatch<AgendaMarkRequest, void>('/api/agenda/mark', req);
}

// Count of active index/ETF-fund holdings priced with a special-rate code — for
// the "שערים מיוחדים" confirmation.
export function getSpecialRatesCount(): Promise<{ count: number }> {
  return apiGet<{ count: number }>('/api/agenda/special-rates-count');
}
